import { MESSAGE_TYPES, NAVIGATION_CHANNEL_NAME, TAB_ID_KEY } from "../constants/broadcastConstants";

export function awaitWindowClaim(): Promise<boolean> {
    if (!('BroadcastChannel' in window)) return Promise.resolve(true);

    return new Promise((resolve) => {
        const bc = new BroadcastChannel(NAVIGATION_CHANNEL_NAME);
        let myTabId = sessionStorage.getItem(TAB_ID_KEY);

        if (!myTabId) {
            myTabId = Math.random().toString(36).slice(2);
            sessionStorage.setItem(TAB_ID_KEY, myTabId);
        }

        let claimed = false;

        const cleanup = () => {
            bc.close();
            resolve(!claimed); // true = allowed to render, false = claimed by other tab
        };

        // Listen for claims from existing tab
        bc.onmessage = (ev: MessageEvent) => {
            const data = ev.data;
            if (data?.type === MESSAGE_TYPES.CLAIM_WINDOW && data?.url === window.location.href) {
                claimed = true;
                // Close immediately if opened by script
                try {
                    if (window.opener && typeof window.close === 'function') {
                        window.close();
                    }
                } catch (_) {}
                cleanup();
            }
        };

        // If opened by script (window.opener), broadcast NAVIGATE request
        if (window.opener) {
            const payload = {
                type: MESSAGE_TYPES.NAVIGATE_TO_URL,
                url: window.location.href,
                senderId: myTabId,
            };
            let sent = 0;
            const interval = setInterval(() => {
                if (claimed) {
                    clearInterval(interval);
                    return;
                }
                bc.postMessage(payload);
                if (++sent >= 6) { // ~900ms
                    clearInterval(interval);
                }
            }, 150);
        } else {
            // Not opened by script -> allow immediately
            cleanup();
        }

        // Max wait 1s
        setTimeout(() => cleanup(), 1000);
    });
}
